var _mask, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.6,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_2_36",
    maskUnits: "userSpaceOnUse",
    x: 6.5,
    y: 8.5,
    width: 11,
    height: 7
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 6.5,
    y: 8.5,
    width: 11,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3212 14.3673L16.3671 10.2835C16.5443 10.1044 16.5443 9.81404 16.3671 9.63439C16.19 9.4552 15.9023 9.4552 15.7251 9.63439L12.0002 13.3942L8.27532 9.63485C8.09818 9.45565 7.81045 9.45565 7.63286 9.63485C7.45571 9.81404 7.45571 10.1048 7.63286 10.284L11.6788 14.3677C11.8541 14.5442 12.1463 14.5442 12.3212 14.3673Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3212 14.3673L16.3671 10.2835C16.5443 10.1044 16.5443 9.81404 16.3671 9.63439C16.19 9.4552 15.9023 9.4552 15.7251 9.63439L12.0002 13.3942L8.27532 9.63485C8.09818 9.45565 7.81045 9.45565 7.63286 9.63485C7.45571 9.81404 7.45571 10.1048 7.63286 10.284L11.6788 14.3677C11.8541 14.5442 12.1463 14.5442 12.3212 14.3673Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3212 14.3673L16.3671 10.2835C16.5443 10.1044 16.5443 9.81404 16.3671 9.63439C16.19 9.4552 15.9023 9.4552 15.7251 9.63439L12.0002 13.3942L8.27532 9.63485C8.09818 9.45565 7.81045 9.45565 7.63286 9.63485C7.45571 9.81404 7.45571 10.1048 7.63286 10.284L11.6788 14.3677C11.8541 14.5442 12.1463 14.5442 12.3212 14.3673Z",
    strokeWidth: 0.6,
    mask: "url(#path-1-outside-1_2_36)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevronDown.68d6e761cb49ad867060302d301d2c5f.svg";
export { ForwardRef as ReactComponent };